import { useQuery } from '@tanstack/react-query';

import { getRewardsRedemption } from '@arrived/api_v2';
import { Rewards } from '@arrived/models';

import { UseQueryOptions, UseQueryResult } from '../queries.utils';
import { promotionUsageKeyFn } from './rewards.keys';

export function useGetRewardsRedemptionQuery(
  rewardsRedemptionUuid?: string,
  options?: UseQueryOptions<Rewards.RewardRedemption>
): UseQueryResult<Rewards.RewardRedemption> {
  return useQuery(
    promotionUsageKeyFn(rewardsRedemptionUuid!),
    async () => getRewardsRedemption(rewardsRedemptionUuid!),
    {
      enabled: (options?.enabled ?? true) && rewardsRedemptionUuid !== undefined,
    }
  );
}
